import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Task from '../pages/task/index.vue'/* 任务推荐 */
import PinglunDetail from '../pages/pl/PinglunDetail.vue'/* 评论 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import FundManage from '../pages/mine/FundManage.vue'/* 资金管理 */
import UsdtAddress from '../pages/mine/UsdtAddress.vue'/* USDT地址 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Recharge  from '../pages/mine/Recharge'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import GameDetail  from '../pages/mine/GameDetail'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import MoneyLog  from '../pages/mine/MoneyLog'/* 提现记录 */
import Mymove  from '../pages/mine/Mymove'/* 提现记录 */






Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'Gentle Meet'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'Gentle Meet'}},
	{path:'/Task',name:'task',component:Task,meta:{title:'Task'}},
	{path:'/Choose',redirect:'/Home'},
	{path:'/Pl',redirect:'/Home'},
    {path:'/PinglunDetail',name:'PinglunDetail',component:PinglunDetail,meta:{title:'評論詳情'}},
	{path:'/List',name:'list',component:List,meta:{title:'個人資料'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'個人資料'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'Gentle Meet - 我的'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'影片'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'遊戲'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'登入'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'註冊'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'線上客服'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'線上客服'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'設定'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'基本資料'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'修改實名'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'修改性別'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'支付密碼管理'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'登入密碼管理'}},
    {path:'/FundManage',name:'FundManage',component:FundManage,meta:{title:'資金管理'}},
    {path:'/UsdtAddress',name:'UsdtAddress',component:UsdtAddress,meta:{title:'USDT地址'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'詳細資訊頁'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'Gentle Meet - 系統公告'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'影片播放'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'綁定收款卡'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'綁定收款卡'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'提款'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'充值'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'个人报表'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'提款記錄'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'任務記錄'}},
    {path:'/GameDetail',name:'GameDetail',component:GameDetail,meta:{title:'任務詳情'}},
    {path:'/MoneyLog',name:'MoneyLog',component:MoneyLog,meta:{title:'資金明細'}},
    {path:'/Mymove',name:'Mymove',component:Mymove,meta:{title:'Gentle Meet - 我的電影'}},


];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to, from, next) => {
    document.title = 'Gentle Meet'
    next()
})

export default router